import { ElementAction } from '@utils/types'
import Tag from '@utils/Tag'

const SCREEN_NAME = 'clt:refin:documents'
const SECTION = 'documents'
const ACTION_ID = 'Envio de documentos'
const REF_FIGMA = '2'

interface AppTagOverrides {
  content_action?: string
  ref_type?: string
  sub_section?: string
  scenario?: string
  step?: string
}

interface WebTagOverrides {
  element_action?: ElementAction
  sub_section?: string
  scenario?: string
  redirect_url?: string
}

export const sendAppDocumentTag = (overrides: AppTagOverrides = {}) =>
  Tag.enviarTagueamentoApp({
    screen: SCREEN_NAME,
    screen_name: SCREEN_NAME,
    ref_type: '',
    content_action: 'Dado carregado',
    action_id: ACTION_ID,
    section: SECTION,
    sub_section: '',
    step: '',
    scenario: 'success',
    ref_figma: REF_FIGMA,
    ...overrides,
  })

export const sendWebDocumentTag = (overrides: WebTagOverrides = {}) =>
  Tag.enviarTagueamentoWeb({
    element_action: 'page_loaded',
    element_name: ACTION_ID,
    c_page: window.location.href,
    redirect_url: '',
    section_name: 'payrollloan:refin:upload',
    section: 'upload',
    sub_section: '',
    step: '',
    scenario: 'success',
    ...overrides,
  })
